import * as cx from 'classnames';
import assetUrl from 'mk/common/assetUrl';
import Img from 'mk2/components/Img';
import * as React from 'react';

export const ACTIONS = {
    CANCEL: 'CANCEL' as 'CANCEL',
    ROTATE: 'ROTATE' as 'ROTATE',
    CHOOSE: 'CHOOSE' as 'CHOOSE',
    LEFT: 'LEFT' as 'LEFT',
    RIGHT: 'RIGHT' as 'RIGHT',
};

const BUTTON_IMGS = {
    CANCEL: 'action-file-delete-gray@2x',
    ROTATE: 'action-image-rotate@2x',
    CHOOSE: 'action-file-choose@2x',
    LEFT: 'action-file-left-gray@2x',
    RIGHT: 'action-file-right-gray@2x',
};

interface OwnProps {
    action: 'CANCEL' | 'ROTATE' | 'CHOOSE' | 'LEFT' | 'RIGHT';

    onClick();
}

export class ActionButton extends React.Component<OwnProps> {
    public render() {
        const {action, onClick} = this.props;

        return (
            <Img
                className={cx('action-button', action.toLowerCase())}
                src={assetUrl + 'img/icons/bazaar/' + BUTTON_IMGS[action] + '.png'}
                onClick={onClick}
                width={28}
                height={28}
            />
        );
    }
}
